<div
    class="ca-tag flex justify-center items-center gap-1"
    [ngClass]="type() + ' ' + (outline() ? 'label-outline' : '') + ' ' + (rounded() ? 'label-rounded' : '')"
>
    @if(tooltip(); as tooltip) {
    <mat-icon [matTooltip]="tooltip">info_outline</mat-icon>
    }
    <ng-content></ng-content>
</div>
